// Products
// Common
import Consent from './common/Consent.svg';
import Heart from './common/Heart.svg';
import Stop from './common/Stop.svg';
import CreditCard from './products/CreditCard.svg';
import CreditLoan from './products/CreditLoan.svg';
import SecuredLoanATV from './products/SecuredLoanATV.svg';
import SecuredLoanBoat from './products/SecuredLoanBoat.svg';
import SecuredLoanCampingCar from './products/SecuredLoanCampingCar.svg';
import SecuredLoanCampingCaravan from './products/SecuredLoanCampingCaravan.svg';
import SecuredLoanCar from './products/SecuredLoanCar.svg';
import SecuredLoanCarElectric from './products/SecuredLoanCarElectric.svg';
import SecuredLoanCarNoInsurance from './products/SecuredLoanCarNoInsurance.svg';
import SecuredLoanMC from './products/SecuredLoanMC.svg';
import SecuredLoanOther from './products/SecuredLoanOther.svg';
import SecuredLoanSnowmobile from './products/SecuredLoanSnowmobile.svg';

export type Assets =
    | 'CreditCard'
    | 'CreditLoan'
    | 'SecuredLoanCar'
    | 'SecuredLoanCarElectric'
    | 'SecuredLoanCarNoInsurance'
    | 'SecuredLoanMC'
    | 'SecuredLoanATV'
    | 'SecuredLoanSnowmobile'
    | 'SecuredLoanCampingCar'
    | 'SecuredLoanCampingCaravan'
    | 'SecuredLoanBoat'
    | 'SecuredLoanOther'
    | 'Consent'
    | 'Heart'
    | 'Stop';

export const assetList = {
    Consent,
    Heart,
    Stop,
    CreditCard,
    CreditLoan,
    SecuredLoanCar,
    SecuredLoanCarElectric,
    SecuredLoanCarNoInsurance,
    SecuredLoanMC,
    SecuredLoanATV,
    SecuredLoanSnowmobile,
    SecuredLoanCampingCar,
    SecuredLoanCampingCaravan,
    SecuredLoanBoat,
    SecuredLoanOther,
};

export const getAssetByName = (asset: Assets) => assetList[asset];

// Products
/*
export { default as CreditCard } from './products/CreditCard.svg';
export { default as CreditLoan } from './products/CreditLoan.svg';
export { default as SecuredLoanCar } from './products/SecuredLoanCar.svg';
export { default as SecuredLoanCarElectric } from './products/SecuredLoanCarElectric.svg';
export { default as SecuredLoanCarNoInsurance } from './products/SecuredLoanCarNoInsurance.svg';
export { default as SecuredLoanMC } from './products/SecuredLoanMC.svg';
export { default as SecuredLoanATV } from './products/SecuredLoanATV.svg';
export { default as SecuredLoanSnowmobile } from './products/SecuredLoanSnowmobile.svg';
export { default as SecuredLoanCampingCar } from './products/SecuredLoanCampingCar.svg';
export { default as SecuredLoanCampingCaravan } from './products/SecuredLoanCampingCaravan.svg';
export { default as SecuredLoanBoat } from './products/SecuredLoanBoat.svg';
export { default as SecuredLoanOther } from './products/SecuredLoanOther.svg';
*/
// Common
/*
export { default as Consent } from './common/Consent.svg';
export { default as Heart } from './common/Heart.svg';
export { default as Stop } from './common/Stop.svg';
*/
